export const setAccessToken = (accessToken: string) => {
  window.sessionStorage.setItem("x-at", accessToken);
};
export const setRefreshToken = (refreshToken: string) => {
  window.sessionStorage.setItem("x-rt", refreshToken);
};

export const getRefreshToken = () => window.sessionStorage.getItem("x-rt");
export const getAccessToken = () => window.sessionStorage.getItem("x-at");
